import React, { useEffect, useState, useLayoutEffect } from 'react';
import {Platform, Text, View, StyleSheet,Button, Alert,FlatList, Image,TouchableOpacity, SafeAreaView, ScrollView  } from 'react-native'
import { WebView } from 'react-native-webview';
import Modal from "react-native-modal";
import { useNavigation } from '@react-navigation/native';
import { useRoute } from '@react-navigation/native';
import { useTailwind } from 'tailwind-rn';
import * as FileSystem from 'expo-file-system';

//My components 
import Header from './Header';
import Footer from './Footer';
import CuadroPestana from './cards/SubCuadroTema/CuadroPestana';

const Tema = ( ) => {

    const { params: {
        titulo,
        contenido
    }} = useRoute();

    const tailwind = useTailwind(); 
    const navigation = useNavigation();
    

    useLayoutEffect(() => {
        navigation.setOptions({
            headerShown: false,
        });
    }, []);


    let goUploadJson = (object) => {
      console.log("presionado");
      navigation.navigate("Json uploader");
    }

    console.log("Tema:");
    console.log(contenido);
    //const [assets, error] = useAssets([require('../assets/matcon-logo1.png'), require('../assets/matcon-logo1.png')]);

    return (
        <SafeAreaView>
            <Header/>
            <ScrollView style={ tailwind("bg-white") }>
                <Text>{ titulo["esp"] }</Text>
                {
                    contenido.map((conti, index) => {
                        return (
                          <CuadroPestana
                                nombre = { conti["titulo"] }
                                contenido = { conti["contenido"] }
                          />
                        )
                      })
                }
                <Footer/>
            </ScrollView>
        </SafeAreaView>
    );
};



    export default Tema;